interface MessageActionsProps {
  isMine: boolean
  onEdit: () => void
  onDelete: () => void
}

export function MessageActions({ isMine, onEdit, onDelete }: MessageActionsProps) {
  return (
    <div
      className={`absolute top-0 flex gap-0.5 rounded-md bg-(--color-bg-primary) p-0.5 shadow-sm border border-(--color-border) ${
        isMine ? 'left-0 -translate-x-full' : 'right-0 translate-x-full'
      }`}
    >
      <button
        onClick={onEdit}
        className="rounded p-1 text-(--color-text-muted) hover:bg-(--color-bg-tertiary) hover:text-(--color-text-primary) transition-colors"
        title="Editar"
      >
        <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
        </svg>
      </button>
      <button
        onClick={onDelete}
        className="rounded p-1 text-(--color-text-muted) hover:bg-(--color-danger)/10 hover:text-(--color-danger) transition-colors"
        title="Excluir"
      >
        <svg className="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </button>
    </div>
  )
}
